import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-day1html',
  templateUrl: './day1html.component.html',
  styleUrls: ['./day1html.component.css']
})
export class Day1htmlComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
